<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main">
                        <h4 class="text-capitalize fw-500 breadcrumb-title">Riwayat Transaksi</h4>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            :totalRows="table.total_records" :isLoading.sync="table.isLoading" :pagination-options="{
                                enabled: true,
                                dropdownAllowAll: false,
                                perPageDropdown: [10, 25, 50, 100],
                            }" :columns="table.columns" :rows="table.rows">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'created_at'">
                                    {{ formatDate(props.row.created_at) }}
                                </span>
                                <span v-else-if="props.column.field == 'package_name'">
                                    {{ props.row.package ? props.row.package.name : '-' }}
                                </span>
                                <span v-else-if="props.column.field == 'amount'">
                                    <div v-if="props.row.amount_idr && props.row.amount_idr > 0">
                                        {{ formatRupiah(props.row.amount_idr) }}
                                    </div>
                                    <div v-else class="text-muted">
                                        ${{ props.row.amount }}
                                    </div>
                                </span>
                                <span v-else-if="props.column.field == 'payment_method'">
                                    <span v-if="props.row.payment_method == 'transfer'" class="badge badge-info">
                                        <i class="fas fa-university mr-1"></i> Transfer Bank
                                    </span>
                                    <span v-else-if="props.row.payment_method == 'paypal'" class="badge badge-primary">
                                        <i class="fab fa-paypal mr-1"></i> PayPal
                                    </span>
                                    <span v-else class="badge badge-secondary">-</span>
                                </span>
                                <span v-else-if="props.column.field == 'status'">
                                    <span v-if="props.row.status == 'paid'" class="badge badge-success">Lunas</span>
                                    <span v-else-if="props.row.status == 'pending'" class="badge badge-warning text-white">Menunggu Pembayaran</span>
                                    <span v-else-if="props.row.status == 'expired'" class="badge badge-secondary">Kedaluwarsa</span>
                                    <span v-else-if="props.row.status == 'cancelled'" class="badge badge-danger">Dibatalkan</span>
                                    <span v-else class="badge badge-secondary">{{ props.row.status }}</span>
                                </span>
                                <span v-else-if="props.column.field == 'action'">
                                    <a v-on:click="downloadInvoice(props.row)" class="btn btn-secondary btn-sm text-white margin5" title="Download Invoice PDF">
                                        <i class="fas fa-file-pdf mr-1"></i> Download PDF
                                    </a>
                                    <a v-if="props.row.status == 'pending' && props.row.payment_method == 'paypal'"
                                        v-on:click="payInvoice(props.row)" class="btn btn-primary btn-sm text-white margin5">
                                        Bayar
                                    </a>
                                    <a v-if="props.row.status == 'pending' && props.row.payment_method == 'transfer'"
                                        v-on:click="showTransferInstructions(props.row)" class="btn btn-info btn-sm text-white margin5">
                                        Instruksi Transfer
                                    </a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>

            <!-- Bank transfer instructions modal -->
            <modal name="transfer_instructions" :height="'auto'" :adaptive="true" :scrollable="true">
                <div class="p-30">
                    <h5 class="mb-3">Instruksi Transfer Bank</h5>

                    <div class="info-box mb-3">
                        <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Nomor Invoice</label>
                        <div style="font-size:16px;font-weight:500;">{{ transferInvoice.invoice_number }}</div>
                    </div>
                    <div class="info-box mb-3" v-if="transferInvoice.unique_code">
                        <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Kode Unik</label>
                        <div style="font-size:20px;font-weight:700;color:#d97706;">{{ transferInvoice.unique_code }}</div>
                    </div>
                    <div class="info-box mb-3" style="padding:15px;background:#f8f9fa;border-radius:8px;">
                        <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Total Transfer <span v-if="transferInvoice.unique_code">(termasuk kode unik)</span></label>
                        <div style="font-size:18px;font-weight:700;color:#6366f1;">{{ formatRupiah(transferInvoice.total_transfer || transferInvoice.amount_idr) }}</div>
                        <small v-if="transferInvoice.unique_code" class="text-muted d-block mt-1">
                            {{ formatRupiah(transferInvoice.amount_idr) }} + kode unik {{ transferInvoice.unique_code }}
                        </small>
                    </div>

                    <div v-for="(account, index) in transferAccounts" :key="index" class="info-box mb-3" style="padding:15px;background:#f8f9fa;border-radius:8px;">
                        <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">{{ account.bank }}</label>
                        <div style="font-size:16px;font-weight:500;">
                            {{ account.number }}
                            <small class="text-muted d-block">a.n. {{ account.name }}</small>
                        </div>
                    </div>

                    <p class="text-muted small">
                        Cantumkan nomor invoice pada berita transfer. Pembayaran diverifikasi admin maksimal 1x24 jam.
                    </p>

                    <button class="btn btn-primary btn-block" @click="$modal.toggle('transfer_instructions')">Tutup</button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    total_records: 0,
                    isLoading: true,
                    columns: [{
                            label: "Tanggal",
                            field: "created_at",
                            sortable: false,
                        },
                        {
                            label: "No. Invoice",
                            field: "invoice_number",
                            sortable: false,
                        },
                        {
                            label: "Paket",
                            field: "package_name",
                            sortable: false,
                        },
                        {
                            label: "Nominal",
                            field: "amount",
                            sortable: false,
                        },
                        {
                            label: "Metode",
                            field: "payment_method",
                            sortable: false,
                        },
                        {
                            label: "Status",
                            field: "status",
                            sortable: false,
                        },
                        {
                            label: "Action",
                            field: "action",
                            sortable: false,
                        },
                    ],
                    rows: [],
                    params: {
                        page: 1,
                        limit: 10,
                    },
                },
                transferInvoice: {
                    invoice_number: '',
                    amount_idr: 0,
                    unique_code: 0,
                    total_transfer: 0,
                },
                transferAccounts: [],
            };
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fnRefreshTable);
        },
        mounted() {
            this.fnRefreshTable = () => {
                this.loadData();
            }
            this.$root.$on("refresh_table", this.fnRefreshTable);
            this.loadData();
        },
        methods: {
            async loadData() {
                this.table.isLoading = true;
                try {
                    let response = await this.$store.dispatch('invoice/invoice_list', this.table.params);
                    this.table.rows = response.data.data.invoices || [];
                    this.table.total_records = response.data.data.total_records || 0;
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Gagal memuat riwayat transaksi");
                } finally {
                    this.table.isLoading = false;
                }
            },
            formatDate(date) {
                if (!date) return '-'
                return moment(date).format('DD MMM YYYY HH:mm')
            },
            formatRupiah(numb) {
                if (!numb && numb !== 0) return '-'
                const format = numb.toString().split('').reverse().join('');
                const convert = format.match(/\d{1,3}/g);
                const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
                return rupiah
            },
            async payInvoice(row) {
                try {
                    let response = await this.$store.dispatch('invoice/invoice_pay', { id: row.id });
                    let checkoutURL = response.data.data.checkout_url;
                    if (checkoutURL) {
                        window.location.href = checkoutURL;
                    } else {
                        this.$toast.error('Gagal mendapatkan link pembayaran');
                    }
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Gagal memproses pembayaran');
                }
            },
            async showTransferInstructions(row) {
                try {
                    let response = await this.$store.dispatch('invoice/invoice_pay', { id: row.id });
                    let data = response.data.data;
                    this.transferInvoice = {
                        invoice_number: data.invoice_number || row.invoice_number,
                        amount_idr: data.amount_idr || row.amount_idr,
                        unique_code: data.unique_code || row.unique_code || 0,
                        total_transfer: data.total_transfer || 0,
                    };
                    this.transferAccounts = data.bank_accounts || [];
                    this.$modal.toggle('transfer_instructions');
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Gagal memuat instruksi transfer');
                }
            },
            onPageChange(params) {
                this.table.params.page = params.currentPage;
                this.loadData();
            },
            onPerPageChange(params) {
                this.table.params.limit = params.currentPerPage;
                this.loadData();
            },
            async downloadInvoice(row) {
                try {
                    let response = await this.$store.dispatch('invoice/invoice_download_pdf', { id: row.id });
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'Invoice-' + row.invoice_number + '.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Gagal download invoice');
                }
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }

    .info-box {
        padding: 15px;
        background: #f8f9fa;
        border-radius: 8px;
    }

    .info-label {
        font-size: 12px;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 5px;
        display: block;
        font-weight: 600;
    }
</style>
